import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import useAuthStore from "../store/authStore";
import styles from "./Auth.module.css";
import LoadingScreen from "../components/chat/LoadingScreen";

const getStrength = (pw) => {
  if (!pw) return { score: 0, label: "", color: "" };
  let score = 0;
  if (pw.length >= 6)  score++;
  if (pw.length >= 10) score++;
  if (/[A-Z]/.test(pw)) score++;
  if (/[0-9]/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  const map = [
    { label: "", color: "#253545", w: "0%" },
    { label: "Very weak", color: "#ef4444", w: "20%" },
    { label: "Weak", color: "#f97316", w: "40%" },
    { label: "Fair", color: "#f59e0b", w: "60%" },
    { label: "Strong", color: "#10b981", w: "80%" },
    { label: "Very strong", color: "#34d399", w: "100%" },
  ];
  return map[score];
};

const Register = () => {
  const navigate = useNavigate();
  const { register, isLoading } = useAuthStore();
  const [form, setForm] = useState({ name: "", email: "", password: "", confirmPassword: "" });
  const strength = getStrength(form.password);
  const [showLoader, setShowLoader] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) return toast.error("Passwords do not match");
    if (form.password.length < 6) return toast.error("Password must be at least 6 characters");
    const result = await register({ name: form.name, email: form.email, password: form.password });
    if (result.success) {
      setShowLoader(true);
      toast.success("Welcome to Chatify! 🎉");
      setTimeout(() => navigate("/"), 1000);
    } else toast.error(result.message || "Something went wrong. Please try again.");
  };

  if (showLoader) return <LoadingScreen message="Creating your account…" />;

  return (
    <div className={styles.authPage}>
      <div className={styles.authCard}>
        <div className={styles.logo}>
          <div className={styles.logoMark}>💬</div>
          <h1>Chatify</h1>
        </div>
        <p className={styles.subtitle}>Create your account — it's free</p>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <label>Full Name</label>
            <input type="text" placeholder="John Doe" value={form.name} required
              onChange={(e) => setForm({ ...form, name: e.target.value })} />
          </div>
          <div className={styles.field}>
            <label>Email</label>
            <input type="email" placeholder="you@example.com" value={form.email} required
              onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div className={styles.field}>
            <label>Password</label>
            <input type="password" placeholder="Min. 6 characters" value={form.password} required
              onChange={(e) => setForm({ ...form, password: e.target.value })} />
            {form.password && (
              <>
                <div className={styles.strengthBar}>
                  <div className={styles.strengthFill} style={{ width: strength.w, background: strength.color }} />
                </div>
                <span className={styles.strengthLabel} style={{ color: strength.color }}>{strength.label}</span>
              </>
            )}
          </div>
          <div className={styles.field}>
            <label>Confirm Password</label>
            <input type="password" placeholder="Repeat password" value={form.confirmPassword} required
              onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })} />
          </div>
          <button type="submit" className={styles.submitBtn} disabled={isLoading}>
            {isLoading ? "Creating account…" : "Create Account"}
          </button>
        </form>

        <p className={styles.switchAuth}>
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
};
export default Register;
